import { useBaseApiCall } from '@/api/factory/base/api';
import { useHandleMutationError } from '@/api/utils';
import { useMutation } from '@tanstack/react-query';

interface AcceptAccountMarketingConsents {
  email: string;
  acceptEmail: boolean;
  acceptPhone?: boolean;
  acceptSms?: boolean;
}

export const useAcceptAccountMarketingConsents = () => {
  const updateConsents = useBaseApiCall<null, [AcceptAccountMarketingConsents]>(
    (api, data) => api.patch('customers/marketingConsents/accept', data),
  );

  const handleMutationError = useHandleMutationError();

  return useMutation({
    mutationFn: updateConsents,
    onError: (_) => {
      handleMutationError(_);
    },
  });
};
